import { render, staticRenderFns } from "./BundleUpdateMember.vue?vue&type=template&id=1d8b945a"
import script from "./BundleUpdateMember.vue?vue&type=script&lang=js"
export * from "./BundleUpdateMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports